import { Component } from '@angular/core';
import { PageHeaderComponent } from '@components/page-header/page-header.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'md-pricing-end-products-page',
  standalone: true,
  imports: [PageHeaderComponent, TranslateModule],
  templateUrl: './pricing-end-products-page.component.html',
  styleUrl: './pricing-end-products-page.component.scss'
})
export class PricingEndProductsPageComponent {}
